var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetailsItineraryRoute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 46,
    viewBox: "0 0 49 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 9.5H24.525M17 44.5L2 37V4.5L7 7M17 44.5L32 37M17 44.5V29.5M32 37L47 44.5V12L42 9.5M32 37V29.5M32 10C32 14.4183 28.25 18 24.5 22C20.75 18 17 14.4183 17 10C17 5.58172 20.3577 2 24.5 2C28.6423 2 32 5.58172 32 10Z",
    stroke: "#48C2C5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailsItineraryRoute);
export default __webpack_public_path__ + "static/media/details-itinerary-route.d680b70251c776ff8171c06d02b65fff.svg";
export { ForwardRef as ReactComponent };